<template>
  <div class="footer">
    <v-footer
      app
      v-if="isFixed"
    >
      <FooterContent />
    </v-footer>
    <v-footer
      v-else
    >
      <FooterContent />
    </v-footer>
  </div>
</template>

<script>
import FooterContent from "@/components/FooterContent"

export default {
  data: () => ({
  }),
  computed: {
    isFixed () {
      if (['xs', 'sm'].includes(this.$vuetify.breakpoint.name)) return false
      return ['page'].includes(this.$route.name)
    }
  },
  components: { FooterContent }
}
</script>


<style>
.footer {
  background: url(/img/footer-bg.jpg) center center no-repeat #000;
}
.theme--light.v-footer {
  color: white !important;
  background-color: transparent !important;
}
div.footer a {
  color: white;
  text-decoration: none;
}
</style>